import { Select } from '@mantine/core'
import { useDisclosure } from '@mantine/hooks'
import axios from 'axios'
import { useCallback, useEffect, useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useVideosInsert } from '../../api/hooks/Videos/useVideosInsert'
import ResultContent from '../../components/admin/ResultContent'
import BaseInput from '../../components/common/BaseInput'
import Label from '../../components/common/Label'
import SaveButton from '../../components/common/SaveButton'
import SaveResultModal from '../../components/common/SaveResultModal'
import styles from '../../styles/admin/StudyContent.module.scss'
import { notifications } from '@mantine/notifications'

const LectureCreateContent = ({ questionId, fromPage,level }) => {
  const navigate = useNavigate()
  const [opened, { open, close }] = useDisclosure(false)
  const [saveStatus, setSaveStatus] = useState(null)
  const [videoLabelInput, setVideoLabelInput] = useState('')
  const [autoSetQueue, setAutoSetQueue] = useState({})
  const [currentAutoStep, setCurrentAutoStep] = useState('none')

  console.log("비디오 페이지 : " , fromPage)
  console.log("비디오 레벨 : ", level)

  const baseUrl = process.env.REACT_APP_API_URL

  const { insertVideo, isPending } = useVideosInsert()

  const [levelOptions, setLevelOptions] = useState([])
  const [mainOptions, setMainOptions] = useState([])
  const [subOptions, setSubOptions] = useState([])
  const [unitOptions, setUnitOptions] = useState([])
  const [detailUnitOptions, setDetailUnitOptions] = useState([])

  const [chapterMeta, setChapterMeta] = useState({
    depth2: '',
    depth3: '',
    depth4: '',
    depth5: '',
  })

  const [formData, setFormData] = useState({
    level: '',
    mainChapter: '',
    subChapter: '',
    unit: '',
    detailUnit: '',
    count: '',
    selectedType: '',
  })

  const createUniqueOptions = useCallback((data, valueKey, depthKey) => {
    if (!Array.isArray(data)) return []

    return data
      .filter(
        (item) =>
          item[valueKey] !== null &&
          item[valueKey] !== undefined &&
          item[valueKey] !== ''
      )
      .map((item) => ({
        value: item[valueKey],
        label: item[valueKey],
        depth: item[depthKey]?.toString() || '',
      }))
      .filter(
        (option, index, array) =>
          array.findIndex((item) => item.value === option.value) === index
      )
  }, [])

  const generateQuestionLabel = useCallback(() => {
    const level = formData.level.replace(/level\s*/i, '').trim()
    const { depth2, depth3, depth4, depth5 } = chapterMeta

    if (!level || !depth2 || !depth3 || !depth4 || !depth5) return ''
    return `${level}-${depth2}-${depth3}-${depth4}-${depth5}`
  }, [formData.level, chapterMeta])

  const questionLabel = useMemo(() => {
    return generateQuestionLabel()
  }, [generateQuestionLabel])

  const handleMainChapterChange = useCallback(
    (value, option) => {
      const mainValue = value || ''
      const depth = option?.depth || ''

      setFormData((prev) => ({ ...prev, mainChapter: mainValue }))
      setChapterMeta((prev) => ({ ...prev, depth2: depth }))

      if (mainValue) {
        fetchSubOptions(formData.level, mainValue)
      }

      setSubOptions([])
      setUnitOptions([])
      setDetailUnitOptions([])
      setFormData((prev) => ({
        ...prev,
        subChapter: '',
        unit: '',
        detailUnit: '',
      }))
      setChapterMeta((prev) => ({
        ...prev,
        depth3: '',
        depth4: '',
        depth5: '',
      }))
    },
    [formData.level]
  )

  const handleSubChapterChange = useCallback(
    (value, option) => {
      const subValue = value || ''
      const depth = option?.depth || ''

      setFormData((prev) => ({ ...prev, subChapter: subValue }))
      setChapterMeta((prev) => ({ ...prev, depth3: depth }))

      if (subValue) {
        fetchUnitOptions(formData.level, formData.mainChapter, subValue)
      }

      setUnitOptions([])
      setDetailUnitOptions([])
      setFormData((prev) => ({
        ...prev,
        unit: '',
        detailUnit: '',
      }))
      setChapterMeta((prev) => ({
        ...prev,
        depth4: '',
        depth5: '',
      }))
    },
    [formData.level, formData.mainChapter]
  )

  const handleUnitChange = useCallback(
    (value, option) => {
      const nextUnit = value || ''
      const depth = option?.depth || ''
      const { level, mainChapter, subChapter } = formData

      setFormData((prev) => ({ ...prev, unit: nextUnit, detailUnit: '' }))
      setChapterMeta((prev) => ({ ...prev, depth4: depth, depth5: '' }))

      if (level && mainChapter && subChapter && nextUnit) {
        fetchDetailUnitOptions(level, mainChapter, subChapter, nextUnit)
      }

      setDetailUnitOptions([])
    },
    [formData]
  )

  const handleDetailUnitChange = useCallback((value, option) => {
    const nextDetail = value || ''
    const depth = option?.depth || ''

    setFormData((prev) => ({ ...prev, detailUnit: nextDetail }))
    setChapterMeta((prev) => ({ ...prev, depth5: depth }))
  }, [])

  const findOption = useCallback((options, searchValue) => {
    if (!options || options.length === 0) return null
    const firstItem = options[0]
    if (typeof firstItem === 'object' && firstItem !== null) {
      let found = options.find((opt) => opt.value === searchValue || opt.label === searchValue)
      if (found) return found
      found = options.find((opt) => opt.depth === searchValue)
      if (found) return found
      found = options.find((opt) => {
        const labelNumbers = opt.label ? opt.label.toString().match(/\d+/g) : []
        const valueNumbers = opt.value ? opt.value.toString().match(/\d+/g) : []
        return (
          (labelNumbers && labelNumbers.includes(searchValue)) ||
          (valueNumbers && valueNumbers.includes(searchValue))
        )
      })
      return found || null
    }
    if (typeof firstItem === 'string') {
      const match =
        options.find((opt) => opt === searchValue) ||
        options.find((opt) => opt.endsWith(` ${searchValue}`) || opt.endsWith(`${searchValue}`))
      return match ? { value: match, label: match, depth: '' } : null
    }
    return null
  }, [])

  const parseVideoLabel = useCallback((input) => {
    const numbers = input.replace(/[^0-9]/g, '')
    let level, main, sub, unit, detailUnit

    if (numbers.length === 5) {
      ;[level, main, sub, unit, detailUnit] = numbers.split('')
    } else if (numbers.length === 6) {
      level = numbers.substring(0, 2)
      main = numbers.charAt(2)
      sub = numbers.charAt(3)
      unit = numbers.charAt(4)
      detailUnit = numbers.charAt(5)
    } else {
      return
    }

    setAutoSetQueue({ level, main, sub, unit, detailUnit })
    setCurrentAutoStep('level')
  }, [])

  const handleVideoLabelKeyDown = useCallback(
    (e) => {
      if (e.key === 'Enter') {
        e.preventDefault()
        parseVideoLabel(videoLabelInput)
      }
    },
    [parseVideoLabel, videoLabelInput]
  )

  const handleCountChange = useCallback((value) => {
    setFormData((prev) => ({ ...prev, count: value }))
  }, [])

  const handleTypeChange = useCallback((value) => {
    setFormData((prev) => ({ ...prev, selectedType: value || '' }))
  }, [])

  const parseDepth = useCallback((input) => {
    const numbers = input.replace(/[^0-9]/g, '')
    if (numbers.length === 5) {
      return {
        LEVEL: parseInt(numbers[0]),
        MAIN: parseInt(numbers[1]),
        SUB: parseInt(numbers[2]),
        UNIT: parseInt(numbers[3]),
        DETAIL_UNIT: parseInt(numbers[4]),
      }
    } else if (numbers.length === 6) {
      return {
        LEVEL: parseInt(numbers.substring(0, 2)),
        MAIN: parseInt(numbers[2]),
        SUB: parseInt(numbers[3]),
        UNIT: parseInt(numbers[4]),
        DETAIL_UNIT: parseInt(numbers[5]),
      }
    }
    return null
  }, [])

  const newRow = () => ({ id: Date.now() + Math.random(), depth: '', title: '', vimeoLink: '', vimeoId: '', hashKey: '' })
  const [videoRows, setVideoRows] = useState([newRow()])
  const [previewRowIndex, setPreviewRowIndex] = useState(0)

  const parseVimeoUrl = useCallback((input) => {
    const trimmed = input.trim()
    const directMatch = trimmed.match(/vimeo\.com\/(\d+)\/([a-f0-9]+)/i)
    if (directMatch) return { id: directMatch[1], hash: directMatch[2] }
    const playerMatch = trimmed.match(/player\.vimeo\.com\/video\/(\d+)(?:[?&]h=([a-f0-9]+))?/i)
    if (playerMatch) return { id: playerMatch[1], hash: playerMatch[2] || '' }
    if (/^\d+$/.test(trimmed)) return { id: trimmed, hash: '' }
    return null
  }, [])

  const updateRow = useCallback((id, field, value) => {
    setVideoRows((prev) => prev.map((r) => (r.id === id ? { ...r, [field]: value } : r)))
  }, [])

  const handleRowVimeoLink = useCallback((id, value, rowIndex) => {
    const parsed = parseVimeoUrl(value)
    setVideoRows((prev) =>
      prev.map((r) =>
        r.id === id
          ? { ...r, vimeoLink: value, ...(parsed ? { vimeoId: parsed.id, hashKey: parsed.hash } : {}) }
          : r
      )
    )
    setPreviewRowIndex(rowIndex)
  }, [parseVimeoUrl])

  const addRow = useCallback(() => {
    setVideoRows((prev) => {
      const updated = [...prev, newRow()]
      setPreviewRowIndex(updated.length - 1)
      return updated
    })
  }, [])

  const removeRow = useCallback((id) => {
    setVideoRows((prev) => {
      if (prev.length === 1) return prev
      const next = prev.filter((r) => r.id !== id)
      setPreviewRowIndex((pi) => Math.min(pi, next.length - 1))
      return next
    })
  }, [])

  const handleSaveWithModal = useCallback(async () => {
    for (let i = 0; i < videoRows.length; i++) {
      const row = videoRows[i]
      if (!row.depth.trim()) {
        notifications.show({ message: `Row ${i + 1}: Depth를 입력해주세요. (예: 34143)`, color: 'red' })
        setPreviewRowIndex(i)
        return
      }
      if (!parseDepth(row.depth)) {
        notifications.show({ message: `Row ${i + 1}: Depth 형식이 올바르지 않습니다. (5~6자리 숫자)`, color: 'red' })
        setPreviewRowIndex(i)
        return
      }
      if (!row.title.trim()) {
        notifications.show({ message: `Row ${i + 1}: Title을 입력해주세요.`, color: 'red' })
        setPreviewRowIndex(i)
        return
      }
      if (!row.vimeoId.trim()) {
        notifications.show({ message: `Row ${i + 1}: Vimeo ID를 입력해주세요.`, color: 'red' })
        setPreviewRowIndex(i)
        return
      }
      if (!row.hashKey.trim()) {
        notifications.show({ message: `Row ${i + 1}: Hash Key를 입력해주세요.`, color: 'red' })
        setPreviewRowIndex(i)
        return
      }
    }

    try {
      await Promise.all(
        videoRows.map((row) => {
          const d = parseDepth(row.depth)
          return insertVideo({
            LEVEL: d.LEVEL,
            MAIN: d.MAIN,
            SUB: d.SUB,
            UNIT: d.UNIT,
            DETAIL_UNIT: d.DETAIL_UNIT,
            TITLE: row.title,
            VIMEO_ID: row.vimeoId,
            HASHKEY: row.hashKey,
          })
        })
      )
      setSaveStatus({ type: 'success', message: `${videoRows.length}개 영상이 저장되었습니다.` })
      open()
      setTimeout(() => {
        navigate('/lectures', { state: { fromPage, level } })
      }, 2000)
    } catch (error) {
      const errorMessage = error?.response?.data?.message
      setSaveStatus({ type: 'error', message: errorMessage })
      open()
    }
  }, [videoRows, parseDepth, insertVideo, open, navigate])

  const handleModalClose = useCallback(() => {
    close()
    setSaveStatus(null)
  }, [close])

  const handleModalConfirm = useCallback(() => {
    if (saveStatus?.type === 'success') {
      navigate('/lectures', { state: { fromPage, level } })
    } else {
      handleModalClose()
    }
  }, [saveStatus, navigate, handleModalClose])

  const fetchLevelOptions = async () => {
    try {
      const res = await axios.post(`${baseUrl}/chapters/list/levels`)
      const levels = res.data.data
        .filter((item) => item.LEVEL !== null && item.LEVEL !== undefined)
        .map((item) => `level ${item.LEVEL}`)
        .filter((level, index, array) => array.indexOf(level) === index)
      setLevelOptions(levels)
    } catch (error) {
      console.error('Level options fetch error:', error)
      setLevelOptions([])
    }
  }

  const fetchMainOptions = async (level) => {
    try {
      const numericLevel = level.replace('level ', '').trim()
      const res = await axios.post(`${baseUrl}/chapters/list/mains`, {
        LEVEL: numericLevel,
      })
      const uniqueOptions = createUniqueOptions(res.data.data, 'MAIN', 'DEPTH2')
      setMainOptions(uniqueOptions)
    } catch (error) {
      console.error('Main options fetch error:', error)
      setMainOptions([])
    }
  }

  const fetchSubOptions = async (LEVEL, MAIN) => {
    try {
      const numericLevel = LEVEL.replace('level ', '').trim()
      const res = await axios.post(`${baseUrl}/chapters/list/subs`, {
        LEVEL: numericLevel,
        MAIN: MAIN,
      })
      const uniqueOptions = createUniqueOptions(res.data.data, 'SUB', 'DEPTH3')
      setSubOptions(uniqueOptions)
    } catch (error) {
      console.error('Sub options fetch error:', error)
      setSubOptions([])
    }
  }

  const fetchUnitOptions = async (LEVEL, MAIN, SUB) => {
    try {
      const numericLevel = LEVEL.replace('level ', '').trim()
      const res = await axios.post(`${baseUrl}/chapters/list/units`, {
        LEVEL: numericLevel,
        MAIN: MAIN,
        SUB: SUB,
      })
      const uniqueOptions = createUniqueOptions(res.data.data, 'UNIT', 'DEPTH4')
      setUnitOptions(uniqueOptions)
    } catch (error) {
      console.error('Unit options fetch error:', error)
      setUnitOptions([])
    }
  }

  const fetchDetailUnitOptions = async (LEVEL, MAIN, SUB, UNIT) => {
    try {
      const numericLevel = LEVEL.replace('level ', '').trim()
      const res = await axios.post(`${baseUrl}/chapters/list/detail_units`, {
        LEVEL: numericLevel,
        MAIN: MAIN,
        SUB: SUB,
        UNIT: UNIT,
      })
      const uniqueOptions = createUniqueOptions(
        res.data.data,
        'DETAIL_UNIT',
        'DEPTH5'
      )
      setDetailUnitOptions(uniqueOptions)
    } catch (error) {
      console.error('Detail unit options fetch error:', error)
      setDetailUnitOptions([])
    }
  }

  useEffect(() => {
    fetchLevelOptions()
  }, [])

  const handleLevelChange = (value) => {
    setFormData((prev) => ({
      ...prev,
      level: value || '',
      mainChapter: '',
      subChapter: '',
      unit: '',
      detailUnit: '',
    }))
    setChapterMeta({
      depth2: '',
      depth3: '',
      depth4: '',
      depth5: '',
    })

    if (typeof value === 'string') {
      fetchMainOptions(value)
    }

    setMainOptions([])
    setSubOptions([])
    setUnitOptions([])
    setDetailUnitOptions([])
  }

  useEffect(() => {
    if (currentAutoStep === 'none' || Object.keys(autoSetQueue).length === 0) return

    switch (currentAutoStep) {
      case 'level': {
        if (autoSetQueue.level) {
          const opt = findOption(levelOptions, autoSetQueue.level)
          if (opt) {
            handleLevelChange(opt.value)
            setCurrentAutoStep('main')
          }
        }
        break
      }
      case 'main': {
        if (autoSetQueue.main && mainOptions.length > 0) {
          const opt = findOption(mainOptions, autoSetQueue.main)
          if (opt) {
            handleMainChapterChange(opt.value, opt)
            setCurrentAutoStep('sub')
          } else {
            setCurrentAutoStep('none')
            setAutoSetQueue({})
          }
        }
        break
      }
      case 'sub': {
        if (autoSetQueue.sub && subOptions.length > 0) {
          const opt = findOption(subOptions, autoSetQueue.sub)
          if (opt) {
            handleSubChapterChange(opt.value, opt)
            setCurrentAutoStep('unit')
          } else {
            setCurrentAutoStep('none')
            setAutoSetQueue({})
          }
        }
        break
      }
      case 'unit': {
        if (autoSetQueue.unit && unitOptions.length > 0) {
          const opt = findOption(unitOptions, autoSetQueue.unit)
          if (opt) {
            handleUnitChange(opt.value, opt)
            setCurrentAutoStep('detailUnit')
          } else {
            setCurrentAutoStep('none')
            setAutoSetQueue({})
          }
        }
        break
      }
      case 'detailUnit': {
        if (autoSetQueue.detailUnit && detailUnitOptions.length > 0) {
          const opt = findOption(detailUnitOptions, autoSetQueue.detailUnit)
          if (opt) {
            handleDetailUnitChange(opt.value, opt)
          }
          setCurrentAutoStep('none')
          setAutoSetQueue({})
        }
        break
      }
      default:
        break
    }
  }, [
    currentAutoStep,
    autoSetQueue,
    levelOptions,
    mainOptions,
    subOptions,
    unitOptions,
    detailUnitOptions,
    findOption,
    handleLevelChange,
    handleMainChapterChange,
    handleSubChapterChange,
    handleUnitChange,
    handleDetailUnitChange,
  ])

  const curriculumData = useMemo(
    () => [
      {
        level: (
          <Select
            placeholder="Level"
            data={levelOptions}
            value={formData.level}
            onChange={handleLevelChange}
            disabled={isPending}
            clearable
          />
        ),
        mainChapter: (
          <Select
            placeholder="Choose Main"
            data={mainOptions}
            value={formData.mainChapter}
            onChange={handleMainChapterChange}
            disabled={isPending || !formData.level}
            clearable
          />
        ),
        subChapter: (
          <Select
            placeholder="Choose Sub"
            data={subOptions}
            value={formData.subChapter}
            onChange={handleSubChapterChange}
            disabled={isPending || !formData.mainChapter}
            clearable
          />
        ),
        unit: (
          <Select
            placeholder="Choose Unit"
            data={unitOptions}
            value={formData.unit}
            onChange={handleUnitChange}
            disabled={isPending || !formData.subChapter}
            clearable
          />
        ),
        detailUnit: (
          <Select
            placeholder="Choose Detail Unit"
            data={detailUnitOptions}
            value={formData.detailUnit}
            onChange={handleDetailUnitChange}
            disabled={isPending || !formData.unit}
            clearable
          />
        ),
        count: (
          <BaseInput
            value={formData.count}
            placeholder="0"
            onChange={(e) => handleCountChange(e.target.value)}
            type="text"
            inputMode="numeric"
            pattern="[0-9]*"
            maxLength={3}
            disabled={isPending}
          />
        ),
        contentType: <Label text="VIDEO" />,
        questionLabel: (
          <input
            value={videoLabelInput}
            placeholder={questionLabel || '51111'}
            onChange={(e) => setVideoLabelInput(e.target.value)}
            onKeyDown={handleVideoLabelKeyDown}
            type="text"
            disabled={isPending}
            style={{
              height: '36px',
              border: '1px solid #ced4da',
              borderRadius: '4px',
              width: '80px',
              padding: '0 8px',
              fontSize: '14px',
            }}
          />
        ),
        type: (
          <Select
            placeholder="Choose Type"
            data={['A', 'B', 'C', 'D', 'E', 'F', 'G']}
            value={formData.selectedType}
            onChange={handleTypeChange}
            disabled={isPending}
            clearable
          />
        ),
      },
    ],
    [
      formData,
      levelOptions,
      mainOptions,
      subOptions,
      unitOptions,
      detailUnitOptions,
      questionLabel,
      videoLabelInput,
      isPending,
      handleMainChapterChange,
      handleSubChapterChange,
      handleUnitChange,
      handleDetailUnitChange,
      handleCountChange,
      handleTypeChange,
      handleVideoLabelKeyDown,
    ]
  )

  const videoData = useMemo(
    () =>
      videoRows.map((row, index) => ({
        depth: (
          <input
            value={row.depth}
            placeholder="34143"
            onChange={(e) => updateRow(row.id, 'depth', e.target.value)}
            onFocus={() => setPreviewRowIndex(index)}
            disabled={isPending}
            maxLength={6}
            style={{
              width: '64px',
              height: '36px',
              border: '1px solid #ced4da',
              borderRadius: '4px',
              padding: '0 8px',
              fontSize: '14px',
            }}
          />
        ),
        videoTitle: (
          <BaseInput
            value={row.title}
            placeholder="Video Title"
            onChange={(e) => updateRow(row.id, 'title', e.target.value)}
            onFocus={() => setPreviewRowIndex(index)}
            disabled={isPending}
            className={styles.videoTitleInput}
          />
        ),
        videoID: (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
            <BaseInput
              value={row.vimeoLink}
              placeholder="Vimeo Link (자동추출)"
              onChange={(e) => handleRowVimeoLink(row.id, e.target.value, index)}
              disabled={isPending}
              className={styles.videoTitleInput}
            />
            <BaseInput
              value={row.vimeoId}
              placeholder="Vimeo ID"
              onChange={(e) => updateRow(row.id, 'vimeoId', e.target.value)}
              onFocus={() => setPreviewRowIndex(index)}
              disabled={isPending}
              className={styles.videoTitleInput}
            />
          </div>
        ),
        hash: (
          <BaseInput
            value={row.hashKey}
            placeholder="Hash Key"
            onChange={(e) => updateRow(row.id, 'hashKey', e.target.value)}
            onFocus={() => setPreviewRowIndex(index)}
            disabled={isPending}
            className={styles.videoTitleInput}
          />
        ),
        actions: (
          <button
            type="button"
            onClick={() => removeRow(row.id)}
            disabled={videoRows.length === 1 || isPending}
            style={{
              background: 'none',
              border: 'none',
              cursor: videoRows.length === 1 ? 'not-allowed' : 'pointer',
              color: videoRows.length === 1 ? '#ccc' : '#ef4444',
              fontSize: '18px',
              lineHeight: 1,
            }}
          >
            ×
          </button>
        ),
        vimeoId: row.vimeoId,
        hashKey: row.hashKey,
        title: row.title,
      })),
    [videoRows, isPending, updateRow, handleRowVimeoLink, removeRow]
  )

  const saveButton = (
    <div
      style={{
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        marginTop: '20px',
      }}
    >
      <SaveButton onClick={handleSaveWithModal} disabled={isPending}>
        {isPending ? 'Saving...' : 'Save'}
      </SaveButton>
    </div>
  )

  return (
    <>
      <ResultContent
        curriculum={[]}
        videoData={videoData}
        showPreview={true}
        showSubject={false}
        saveButton={saveButton}
        previewRowIndex={previewRowIndex}
        onAddRow={addRow}
      />

      <SaveResultModal
        opened={opened}
        onClose={handleModalClose}
        status={saveStatus}
        onConfirm={handleModalConfirm}
      />
    </>
  )
}

export default LectureCreateContent
